
import React, { useEffect } from "react";
// react library for routing
import { NavLink as NavLinkRRD, Link } from "react-router-dom";
// nodejs library that concatenates classes
import classnames from "classnames";
// nodejs library to set properties for components
import { PropTypes } from "prop-types";
// react library that creates nice scrollbar on windows devices
import PerfectScrollbar from "react-perfect-scrollbar";
import { commonService } from '_services/common.service';
import { ToastsContainer, ToastsStore } from 'react-toasts';
import { history } from '_helpers';
import axios from 'axios';

// reactstrap components
import {
  Collapse,
  NavbarBrand,
  Navbar,
  NavItem,
  NavLink,
  Nav
} from "reactstrap";
import PostbuyingneedPopup from "views/Hoc/Dialog/PostbuyingneedPopup";

class Sidebar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      route: [],
      routeFlag: 0,
      collapseOpen: false,
      ...this.getCollapseStates(props.routes),
      sidenavOpens: false,
      PostBuyNeed: false
    };
  }

  async UNSAFE_componentWillMount() {
    let user = JSON.parse(localStorage.getItem('CHuser'));

    let profile_completion_count=user?.profile_completion_count;

    //let profile_completion_count = await commonService.getServices('/setting/checkUserStatus/' + user?.channelId);

    // let pcount = profile.data.filter(x => {
    //   return x?.isCompleted == true;
    // })


    let data = await commonService.getServices('/user/userprevilege/' + user.contactId);
    let key = data.data;
    if (key.length > 0 && user.roleId != 1) {
      console.log("if:", key);
      key.push(1); key.push(21);
      let res = this.props.routes.filter(x => key.includes(+x.status));
      // if (user.channelTypeId != 2) {
      //   res = this.props.routes.filter(x => {
      //     return x.name != 'My Products';// && x.name!= 'Dashboard';
      //   })
      // }
      console.log("menus:", res);
      this.setState({
        route: res,
      });
    }
    // else {
    //   if (user.roleId != 1) {

    //     this.props.routes.map(x => {
    //       x.path = '/dashboard';
    //     })

    //     let res = this.props.routes;

    //     if (user.channelTypeId != 2) {
    //       res = this.props.routes.filter(x => {
    //         return x.name != 'My Products';
    //       })
    //     }

    //     this.setState({
    //       route: res,//this.props.routes,
    //       routeFlag: 1,
    //     });
    //   }
    else {

      let res = this.props.routes;
      if (user.channelTypeId != 2) {
        res = this.props.routes.filter(x => {
          return x.name != 'My Products';
        })
      }
      if(user.isOtherUser == '1'){
         res = this.props.routes.filter(x => 
          { 
            return x.name.includes('Events','Dashboard') 
          }
        );

        res = this.props.routes.filter(x => (x.name == 'Events' || x.name == 'Dashboard' || x.name == 'Help / Report' || x.name == 'My Network' ) );
      }
      if ((user.channelTypeId == 2 && profile_completion_count != 4) || (user.channelTypeId != 2 && profile_completion_count != 2)) {

        res.map(x => {
          x.path = '/dashboard';
        })
        this.setState({
          route: res,//this.props.routes,
          routeFlag: 1,
        });
      }
      else {
        console.log("else");
        this.setState({
          route: res,//this.props.routes,
          routeFlag: 0,
        });
      }
    }

    //console.log("hello:",res);
  }

  enableSideMenu = async () => {
    let user = JSON.parse(localStorage.getItem('CHuser'));

    let profile_completion_count=user?.profile_completion_count;
    //let profile_completion_count = await commonService.getServices('/setting/checkUserStatus/' + user?.channelId);

    // let pcount = profile.data.filter(x => {
    //   return x?.isCompleted == true;
    // })


    // let data = await commonService.getServices('/user/userprevilege/' + user.contactId);
    // let key = data.data;
    // if (key.length > 0 && user.roleId != 1) {

    //   let res = this.props.routes.filter(i => key.includes(i.status));
    //   if (user.channelTypeId != 2) {
    //     res = this.props.routes.filter(x => {
    //       return x.name != 'My Products';
    //     })
    //   }
    //   this.setState({
    //     route: res,
    //   });
    // }
    // else {
    //   if (user.roleId != 1) {

    //     this.props.routes.map(x => {
    //       x.path = '/dashboard';
    //     })

    //     let res = this.props.routes;

    //     if (user.channelTypeId != 2) {
    //       res = this.props.routes.filter(x => {
    //         return x.name != 'My Products';
    //       })
    //     }

    //     this.setState({
    //       route: res,//this.props.routes,
    //       routeFlag: 1,
    //     });
    //   }
    // else {
    let res = this.props.routes;
    if (user.channelTypeId != 2) {
      res = this.props.routes.filter(x => {
        return x.name != 'My Products';
      })
    }
    if ((user.channelTypeId == 2 && profile_completion_count != 4) || (user.channelTypeId != 2 && profile_completion_count != 2)) {

      res.map(x => {
        x.path = '/dashboard';
      })
      this.setState({
        route: res,//this.props.routes,
        routeFlag: 1,
      });
    }
    else {

      this.setState({
        route: res,//this.props.routes,
        routeFlag: 0,
      });
    }
    //}

    //console.log("hello:",res);
  }
  // verifies if routeName is the one active (in browser input)
  activeRoute = routeName => {
    return this.props.location.pathname.indexOf(routeName) > -1 ? "active" : "";
  };
  // makes the sidenav normal on hover (actually when mouse enters on it)
  onMouseEnterSidenav = () => {

    //setTimeout(function () { //Start the timer
    this.state.sidenavOpens = true;
    this.setState({
      sidenavOpens: this.state.sidenavOpens
    });

    if (!document.body.classList.contains("g-sidenav-pinned")) {
      document.body.classList.add("g-sidenav-show");
    }
    //}.bind(this), 1000)
    //console.log("menu:", this.state.sidenavOpens);

  };
  // makes the sidenav mini on hover (actually when mouse leaves from it)
  onMouseLeaveSidenav = () => {
    if (!document.body.classList.contains("g-sidenav-pinned")) {
      document.body.classList.remove("g-sidenav-show");
    }
    //setTimeout(function () { //Start the timer
    this.state.sidenavOpens = false;
    this.setState({
      sidenavOpens: this.state.sidenavOpens
    });
    //}.bind(this), 1000)
  };

  Postbyneed = (e, name) => {
    if (name == 'Post Your Buying Need') {

      this.setState({
        PostBuyNeed: true
      });
      console.log('this.state.PostBuyNeed', this.state.PostBuyNeed);
      e.preventDefault();
    }
    //this.state.PostBuyNeed
  };
  Postclose = () => {
    //e.preventDefault()
    console.log('this.state.Postclose', this.state.Postclose);
    this.setState({
      PostBuyNeed: false
    });
  }
  // toggles collapse between opened and closed (true/false)
  toggleCollapse = () => {
    this.setState({
      collapseOpen: !this.state.collapseOpen
    });
  };
  // closes the collapse
  closeCollapse = () => {
    this.setState({
      collapseOpen: false
    });
  };
  // this creates the intial state of this component based on the collapse routes
  // that it gets through this.props.routes
  getCollapseStates = routes => {
    let initialState = {};
    routes.map((prop, key) => {
      if (prop.collapse) {
        initialState = {
          [prop.state]: this.getCollapseInitialState(prop.views),
          ...this.getCollapseStates(prop.views),
          ...initialState
        };
      }
      return null;
    });
    return initialState;
  };
  // this verifies if any of the collapses should be default opened on a rerender of this component
  // for example, on the refresh of the page,
  // while on the src/views/forms/RegularForms.js - route /admin/regular-forms
  getCollapseInitialState(routes) {
    for (let i = 0; i < routes.length; i++) {
      if (routes[i].collapse && this.getCollapseInitialState(routes[i].views)) {
        return true;
      } else if (window.location.href.indexOf(routes[i].path) !== -1) {
        return true;
      }
    }
    return false;
  }
  // this is used on mobile devices, when a user navigates
  // the sidebar will autoclose
  closeSidenav = async (path) => {
    console.log("routeFlag:", path);
    if (this.state.routeFlag == 1) {
      let user = JSON.parse(localStorage.getItem('CHuser'));

   
      let profile_completion_count=user?.profile_completion_count;
      //let profile_completion_count = await commonService.getServices('/setting/checkUserStatus/' + user?.channelId);

      if ((user.channelTypeId == 2 && profile_completion_count != 4) || (user.channelTypeId != 2 && profile_completion_count != 2))
        ToastsStore.warning('Access denied, Complete initial account setup to continue')
      else {
        this.enableSideMenu();
        history.push(path);
      }
    }
    if (window.innerWidth < 1200) {
      this.props.toggleSidenav();
    }
  };


  // this function creates the links and collapses that appear in the sidebar (left menu)
  createLinks = routes => {
    const user = JSON.parse(localStorage.getItem('CHuser'));
    const selectedUser = JSON.parse(localStorage.getItem('selectCHUser'));
 
    return routes.map((prop, key) => {
      //  console.log('prop',prop)
      
      if(user.isMaster == true && !selectedUser && (prop.name=="Suggestion" || prop.name=="My Products" || prop.name=="My Network" || prop.name=="Events")) {
        return
      }

      if (prop.redirect) {
        return null;
      }
      if (prop.collapse) {
        var st = {};
        st[prop["state"]] = !this.state[prop.state];
        return (
          <NavItem key={key}>
            <NavLink
              href="#pablo"
              data-toggle="collapse"
              aria-expanded={this.state[prop.state]}
              className={classnames({
                active: this.getCollapseInitialState(prop.views)
              })}
              onClick={e => {
                e.preventDefault();
                this.setState(st);
              }}
            >
              {prop.icon ? (
                <>
                  <i className={prop.icon} />
                  <span className="nav-link-text">{prop.name}</span>
                </>
              ) : prop.miniName ? (
                <>
                  <span className="sidenav-mini-icon"> {prop.miniName} </span>
                  <span className="sidenav-normal"> {prop.name} </span>
                </>
              ) : null}
            </NavLink>
            <Collapse isOpen={this.state[prop.state]}>
              <Nav className="nav-sm flex-column">
                {this.createLinks(prop.views)}
              </Nav>
            </Collapse>
          </NavItem>
        );
      }
      return (
        <>

          {prop.name &&
            <NavItem
              className={this.activeRoute(prop.layout + prop.path)}
              key={key}
            >
              <NavLink
                to={prop.path != '/Postbuyneed' ? prop.layout + prop.path : '/#'}
                activeClassName=""
                onClick={e => { this.closeSidenav(prop.layout + prop.path); this.Postbyneed(e, prop.name) }}
                tag={NavLinkRRD}
              >
                {prop.icon !== undefined ? (
                  <>
                    <i className={prop.icon} />
                    <span className="nav-link-text">{prop.name} </span>
                  </>
                ) : prop.miniName !== undefined ? (
                  <>
                    <span className="sidenav-mini-icon"> {prop.miniName} </span>
                    <span className="sidenav-normal"> {prop.name} </span>
                  </>
                ) : (
                  prop.name
                )}
              </NavLink>
            </NavItem>
          }
        </>
      );
    });
  };

  render() {
    const { routes, logo } = this.props;
    let navbarBrandProps;
    let user = JSON.parse(localStorage.getItem('CHuser'));

    if (logo && logo.innerLink) {
      if (user) {
        navbarBrandProps = {
          to: '/admin/dashboard',
          tag: Link
        };
      }
      else {
        navbarBrandProps = {
          to: logo.innerLink,
          tag: Link
        };
      }
    } else if (logo && logo.outterLink) {
      navbarBrandProps = {
        href: logo.outterLink,
        target: "_blank"
      };
    }
    const scrollBarInner = (
      <div className="scrollbar-inner">

        <div className="sidenav-header d-flex align-items-center">
          {this.state.sidenavOpens ? (

            <NavbarBrand {...navbarBrandProps}>
              <img onError={(event) => { axios.post('/media/errorLog', { url: event.target.src, documentTypeId: 1, name: null }); event.target.setAttribute("src", process.env.REACT_APP_DEFALTIMAGE+"document/company/logo/zF71l5KG_1548153498529_1548153484685.jpg"); }}
                alt={logo.imgAlt}
                className="navbar-brand-img"
                src={logo.imgSrc}
              />
            </NavbarBrand>
          ) : <NavbarBrand style={{ display: 'block', padding: '1rem' }} {...navbarBrandProps}>
            <img onError={(event) => { axios.post('/media/errorLog', { url: event.target.src, documentTypeId: 1, name: null }); event.target.setAttribute("src", process.env.REACT_APP_DEFALTIMAGE+"document/company/logo/zF71l5KG_1548153498529_1548153484685.jpg"); }}
              alt={logo.imgAlt}
              className="navbar-brand-img w-100"
              src={require('assets/img/brand/logo-icon.svg')}
            />
          </NavbarBrand>}
          <div className="ml-auto">
            <div
              className={classnames("sidenav-toggler d-xl-none d-block", {
                active: this.props.sidenavOpen
              })}
              onClick={this.props.toggleSidenav}
            >
              <div className="sidenav-toggler-inner">
                <i className="sidenav-toggler-line" />
                <i className="sidenav-toggler-line" />
                <i className="sidenav-toggler-line" />
              </div>
            </div>
          </div>
        </div>
        <div className="navbar-inner">

          <Collapse navbar isOpen={true}>
            <Nav navbar>{this.createLinks(this.state.route)}</Nav>
            <hr className="my-3" />

          </Collapse>
        </div>
      </div>
    );
    return (
      <>
        {this.state.PostBuyNeed &&
          <PostbuyingneedPopup open={this.state.PostBuyNeed} PostClose={this.Postclose} />
        }
        <ToastsContainer position="top_right" autoClose={5000} store={ToastsStore} />

        <Navbar id="nav-bar"
          className={
            "sidenav navbar-vertical navbar-expand-xs navbar-light bg-white " +
            (this.props.rtlActive ? "" : "fixed-left")
          }
          onMouseEnter={this.onMouseEnterSidenav}
          onMouseLeave={this.onMouseLeaveSidenav}
        >
          {navigator.platform.indexOf("Win") > -1 ? (
            <PerfectScrollbar>{scrollBarInner}</PerfectScrollbar>
          ) : (
            scrollBarInner
          )}
        </Navbar>
      </>
    );
  }
}

Sidebar.defaultProps = {
  routes: [{}],
  toggleSidenav: () => { },
  Postclose: () => { },
  sidenavOpen: false,
  rtlActive: false
};

Sidebar.propTypes = {
  // function used to make sidenav mini or normal
  toggleSidenav: PropTypes.func,
  Postclose: PropTypes.func,
  // prop to know if the sidenav is mini or normal
  sidenavOpen: PropTypes.bool,
  // links that will be displayed inside the component
  routes: PropTypes.arrayOf(PropTypes.object),
  // logo
  logo: PropTypes.shape({
    // innerLink is for links that will direct the user within the app
    // it will be rendered as <Link to="...">...</Link> tag
    innerLink: PropTypes.string,
    // outterLink is for links that will direct the user outside the app
    // it will be rendered as simple <a href="...">...</a> tag
    outterLink: PropTypes.string,
    // the image src of the logo
    imgSrc: PropTypes.string.isRequired,
    // the alt for the img
    imgAlt: PropTypes.string.isRequired
  }),
  // rtl active, this will make the sidebar to stay on the right side
  rtlActive: PropTypes.bool
};

export default Sidebar;
